import { Pipe, PipeTransform } from '@angular/core';

import { ItemTipo } from '../../item-tipo';

@Pipe({
    name: 'itemTipoSituacaoFilter',
    pure: false
})
export class ItemTipoSituacaoFilterPipe implements PipeTransform {
    /** Filtra os tipos de itens pela situação informada */
    transform(entities: ItemTipo[], situacao: number = null): ItemTipo[] {
        if (!entities) {
            return [];
        }
        // Retorna todos tipos de itens quando não for informada uma situação para filtar
        if (!situacao) {
            return entities;
        }

        return entities.filter(entityFilter => entityFilter.situacao === situacao);
    }
}
